module.exports = __webpack_public_path__ + "img/2heart-05.aea075df.svg";